import { render, staticRenderFns } from "./NewProjects.vue?vue&type=template&id=a90bdade&scoped=true"
import script from "./NewProjects.vue?vue&type=script&lang=js"
export * from "./NewProjects.vue?vue&type=script&lang=js"
import style0 from "./NewProjects.vue?vue&type=style&index=0&id=a90bdade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90bdade",
  null
  
)

export default component.exports